import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  // 密码1
  pwd0: '',
  // 密码2
  pwd1: '',
  // 密码1提示文字
  pwd0Data: '',
  // 密码2提示文字
  pwd1Data: '',
  // 手机号是否通过
  ifPhone: false,
  url:'/activate',
  loginUrl:'/Regest/Index',
  // 弹窗配置
  dialogConfig: {
    ifSuccess: true
    , type: '0'
    , ifShow: 0
    , message: '网络连接失败'
  }

  // 用户名[手机号]
  // , userName: 0
  , userName: ''
  , nsrsbh: ''

  , loginUser: '真实姓名'
  , loginUser1: {name: ''}
}

const getters = {
  getPwd0 (state) {
    return state.pwd0
  },

  getPwd1 (state) {
    return state.pwd1
  },

  ifPhone (state) {
    return state.ifPhone
  },

  getDialogConfig (state) {
    return state.dialogConfig
  }

  , getUserName (state) {
    return state.userName
  }
  , getLoginUser1 (state) {
    return state.loginUser1
  }, getUrl (state) {
    return state.url
  }, getloginUrl (state) {
    return state.loginUrl
  }

  , getNsrsbh (state) {
    return state.nsrsbh
  }
}

const mutations = {
  // 设置密码1
  setPwd0 (state, pwd0Str) {
    state.pwd0 = pwd0Str
  },

  // 设置密码2
  setPwd1 (state, pwd1Str) {
    state.pwd1 = pwd1Str
  },

  // 设置密码1提示文字
  setPwd0ShowText (state, pwd0Data) {
    state.pwd0Data = pwd0Data
  },

  // 开始密码1回调
  doPwd0Show (state, pwd0ShowText) {
    state.pwd0Data.showText = pwd0ShowText
  },

  // 设置密码2提示文字
  setPwd1ShowText (state, pwd1Data) {
    state.pwd1Data = pwd1Data
  },

  // 开始密码1回调
  doPwd1Show (state, pwd1ShowText) {
    state.pwd1Data.showText = pwd1ShowText
  },

  // 重置状态
  resetState (state) {
    state.pwd0Data = ''
    state.pwd1Data = ''
    state.pwd0 = ''
    state.pwd1 = ''
  },

  // 设置手机号状态
  setIfPhone (state, ifPhone) {
    state.ifPhone = ifPhone
  },

  // 设置弹窗配置
  setDialogConfig (state, dialogConfig) {
    state.dialogConfig = dialogConfig
  }
  // 设置用户名username
  , setUserName (state, userName) {
    state.userName = userName
    state.loginUser1.name = userName
  }
  // 设置用户纳税人识别号
  , setNsrsbh (state, nsrsbh) {
    state.nsrsbh = nsrsbh
  }
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js